import { createTheme } from "@mui/material/styles";
import { COLORS } from "../../colors";

const Theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
  typography: {
    fontFamily: "Rubik",
    h1: {
      fontWeight: 700,
      fontSize: "1.8rem",
      lineHeight: "3rem",
      color: COLORS.WAFFY_GRAY_900,
      margin: 0,
    },
    h2: {
      fontWeight: 400,
      fontSize: "1.42rem",
      lineHeight: "2.43rem",
      color: COLORS.WAFFY_GRAY_400,
      margin: 0,
    },
    subtitle1: {
      fontWeight: 400,
      fontSize: "1.3rem",
      lineHeight: "1.37rem",
      color: COLORS.WAFFY_GRAY_800,
    },
    body1: {
      fontWeight: 400,
      fontSize: "1.05rem",
      lineHeight: "1.875rem",
      color: COLORS.WAFFY_GRAY_700,
    },
  },
});

export default Theme;
